import { Dropdown, SearchBar } from "antd-mobile";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterDrawer } from "./components";
import styles from "./style.module.scss";
import "./style.scss";

const FilterWithQuickSearch = ({
  customDropdownStyleClass = "",
  customDropDownContainerStyleClass = "",
  filterSetup = {},
  localFilterValue = {},
  filterDefaultValue = {},
  setLocalFilterValue = () => {},
  onSubmitQuickSearch = () => {},
  onReset = () => {},
  onSubmitSearch = () => {},
  activeTab = "",
  apiValue,
  dependency,
  setDependency,
}) => {
  const searchBar = useRef();
  const { quick_search, filters } = filterSetup;
  const [disableQuickSearch, setDisableQuickSearch] = useState(false);
  const { t } = useTranslation();
  const dropDownRef = useRef();

  const onQuickSearchChange = (e) => {
    setLocalFilterValue((prevState) => {
      return {
        ...prevState,
        [quick_search.data_index]: e,
      };
    });
  };

  const handleOnReset = () => {
    setLocalFilterValue(filterDefaultValue);
    onReset();
  };

  const handleOnSubmitSearch = () => {
    dropDownRef.current.close();
    onSubmitSearch();
  };

  const onDropDownChange = (activeKey) => {
    if (activeKey !== null) {
      setDisableQuickSearch(true);
    } else {
      setDisableQuickSearch(false);
    }
  };

  const renderFilterDrawer = () => {
    // console.log('apiValue', apiValue)
    return (
      <FilterDrawer
        filters={filters}
        localFilterValue={localFilterValue}
        setLocalFilterValue={setLocalFilterValue}
        onReset={handleOnReset}
        onSubmitSearch={handleOnSubmitSearch}
        apiValue={apiValue}
        setDependency={setDependency}
        dependency={dependency}
      />
    );
  };

  const onHandleFocus = () => {
    if (disableQuickSearch === true) {
      searchBar.current.blur();
    }
  };

  //close dropdown when tabs being changed
  useEffect(() => {
    dropDownRef.current.close();
  }, [activeTab]);

  return (
    <div
      className={`${styles.container} ${customDropDownContainerStyleClass} quick-search-filter-container`}
    >
      <SearchBar
        onFocus={onHandleFocus}
        ref={searchBar}
        disabled={true}
        className={`${styles.quickInput} quick-input`}
        placeholder={t("mobile.normal.pleaseInput", {
          name: t(quick_search.title),
        })}
        clearable={false}
        value={localFilterValue[quick_search.data_index]}
        onChange={onQuickSearchChange}
        onSearch={onSubmitQuickSearch}
      />

      <Dropdown ref={dropDownRef} onChange={onDropDownChange}>
        <Dropdown.Item
          key="filter"
          className={`${"quick-dropdown"} ${customDropdownStyleClass}`}
          title={t("mobile.quickFilter.dropdown")}
        >
          {renderFilterDrawer()}
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
};

export default FilterWithQuickSearch;
